var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 5C10.587 5 9.95107 5.26339 9.48223 5.73223C9.01339 6.20107 8.75 6.83696 8.75 7.5V32.5C8.75 33.163 9.01339 33.7989 9.48223 34.2678C9.95107 34.7366 10.587 35 11.25 35H28.75C29.413 35 30.0489 34.7366 30.5178 34.2678C30.9866 33.7989 31.25 33.163 31.25 32.5V17.2853C31.25 17.2853 31.25 17.2852 31.25 17.2852C31.2499 16.9539 31.1183 16.6362 30.8841 16.4019C30.8841 16.4018 30.884 16.4018 30.884 16.4018L19.8482 5.36602C19.6139 5.13175 19.2962 5.0001 18.9648 5C18.9648 5 18.9647 5 18.9647 5H11.25ZM7.71447 3.96447C8.65215 3.02678 9.92392 2.5 11.25 2.5H18.965C19.9592 2.50015 20.9127 2.89511 21.6158 3.59805L21.6159 3.59815L32.652 14.6342C33.3549 15.3373 33.7498 16.2908 33.75 17.285V32.5C33.75 33.8261 33.2232 35.0979 32.2855 36.0355C31.3479 36.9732 30.0761 37.5 28.75 37.5H11.25C9.92392 37.5 8.65215 36.9732 7.71447 36.0355C6.77678 35.0979 6.25 33.8261 6.25 32.5V7.5C6.25 6.17392 6.77678 4.90215 7.71447 3.96447Z",
    fill: "#08152C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 3.125C20.6904 3.125 21.25 3.68464 21.25 4.375V13.75C21.25 14.0815 21.3817 14.3995 21.6161 14.6339C21.8505 14.8683 22.1685 15 22.5 15H31.875C32.5654 15 33.125 15.5596 33.125 16.25C33.125 16.9404 32.5654 17.5 31.875 17.5H22.5C21.5054 17.5 20.5516 17.1049 19.8484 16.4016C19.1451 15.6984 18.75 14.7446 18.75 13.75V4.375C18.75 3.68464 19.3096 3.125 20 3.125Z",
    fill: "#08152C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentOutline);
export default __webpack_public_path__ + "static/media/document-outline.20b4aad56e80df609c1a0a47b88e11ce.svg";
export { ForwardRef as ReactComponent };